// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueJsonp from 'vue-jsonp'
import ElementUI from 'element-ui'
// import ElementUI, { Main } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/sass/element-variables.scss'
import '../static/sass/all.scss'
// import '../static/css/index.css'
import '../static/css/font-awesome.css'
import '../static/css/style.css'
import '../static/css/iconfont.css'
import Router from 'vue-router' // 引入路由

// router-tab 组件依赖 vue 和 vue-router
import RouterTab from 'vue-router-tab'
import 'vue-router-tab/dist/lib/vue-router-tab.css'

import axios from 'axios'
import Qs from 'qs'
import promise from 'es6-promise'
import store from './js/store/store'
import CustomAction from './js/customAction.js'
import CommonComponent from './components/common/common.js'
import utils from './js/utils'
import echarts from 'echarts'
// import storage from './js/storage.js'
// import vueSignature from 'vue-signature'
import './js/filter'
import Global from './js/global_variables'
import IdCard from './js/IdCard'
import router from './router'
import main from "@/components/index.vue"
import iconPicker from 'e-icon-picker';
import {
  analyzingIconForIconfont
} from 'e-icon-picker/dist/index.js';
import "e-icon-picker/dist/symbol.js"; //基本彩色图标库
import 'e-icon-picker/dist/index.css'; // 基本样式，包含基本图标
//import 'font-awesome/css/font-awesome.min.css'; //font-awesome 图标库
//import wxlogin from 'vue-wxlogin';
import iconfont from '../static/fonts/iconfont.json';
let forIconfont = analyzingIconForIconfont(iconfont);

// import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
// Vue.use(VueQuillEditor)

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

import Confirm from '@/components/common/confirm.js'
Vue.prototype.$my_confirm = Confirm.install;

//全局变量
Vue.prototype.validid = IdCard;
Vue.prototype.$g = Global;
Vue.config.devtools = true;
Vue.config.productionTip = false


//日期格式化
Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

// 解决IE不兼容ES6语法问题
promise.polyfill()

// 配置axios
axios.defaults.baseURL = '/api'
//axios.defaults.baseURL = 'http://localhost:60978/api'
axios.defaults.transformRequest = [function (data) {
  return Qs.stringify(data)
}]
axios.defaults.timeout = 90000;
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  config['headers'].Authorization = 'Bearer ' + sessionStorage.getItem('token')
  config['headers'].refresh_token = sessionStorage.getItem('retoken')
  config['headers'].uuid = sessionStorage.getItem('uuid')
  // 在发送请求之前做些什么
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // eslint-disable-next-line eqeqeq
  if (response.status == 401 || response.data.code == 401) {
    store.dispatch('user/removetoken')
    router.replace('/src/components/login.vue')
  }
  // 对响应数据做点什么
  return response
}, function (error) {
  // eslint-disable-next-line eqeqeq
  if (error.response.status == 401) {
    store.dispatch('user/removetoken')
    store.dispatch('user/removeuser')
    router.replace('/login')
  }
  // eslint-disable-next-line eqeqeq
  if (error.response.status == 403) {
    router.replace('/Error/403')
  }
  // eslint-disable-next-line eqeqeq
  // if (error.response.status == 404) {
  //     router.replace('/Error/404')
  // }
  if (error.response.status == 406) {
    router.replace('/Error/406')
  }
  if (error.response.status == 409) {
    router.replace('/Error/409')
  }
  // if (error.response.status >= 500 && error.response.status <= 510) {
  //     // eslint-disable-next-line eqeqeq
  //     if (error.response.status != 504) {
  //         router.replace('/Error/500')
  //     }
  // }
  // 对响应错误做点什么
  return Promise.reject(error)
})

Vue.prototype.$axios = axios
Vue.prototype.$echarts = echarts

Vue.use(ElementUI)
Vue.use(Router) // 注册路由
Vue.use(CustomAction)
Vue.use(store)
Vue.use(CommonComponent)
Vue.use(utils)
// Vue.use(vueSignature)
Vue.use(VueJsonp)
Vue.use(iconPicker, {
  FontAwesome: true,
  ElementUI: true,
  eIcon: true,
  eIconSymbol: true,
  addIconList: forIconfont.list
});

// Vue.component('my-component', {
//   components: {
//     wxlogin
//   }
// });
//注册router-tab   2021-03-10 wms
Vue.config.productionTip = false
Vue.use(RouterTab)

var getRouter; //用来获取后台拿到的路由

//console.info(store.getters["globalConfig/WebSocketUrl"]);

// 路由拦截器
router.beforeEach(async (to, from, next) => {
  // eslint-disable-next-line eqeqeq
  if (store.state.user.token == undefined || store.state.user.token == null) {
    store.state.user.token = sessionStorage.getItem('token')
  }
  // eslint-disable-next-line eqeqeq
  if (store.state.user.UserInfo == undefined || store.state.user.UserInfo == null) {
    try {
      store.state.user.UserInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    } catch (err) {

    }
  }
  if (store.state.permission.RouterList == undefined || store.state.permission.RouterList == null) {
    try {
      store.state.permission.RouterList = JSON.parse(sessionStorage.getItem('RouterList'))
    } catch (err) {

    }
  }
  // eslint-disable-next-line eqeqeq
  if (to.fullPath == '/') {
    next({
      path: '/login'
    })
  } else {
    //#region 动态路由
    //解决页面主动使用localStorage.removeItem('router');会导致该变量没有初始化从而陷入死循环
    if (!store.state.permission.RouterList) {
      getRouter = undefined
    }
    if (!getRouter) { //不加这个判断，路由会陷入死循环
      if (!store.state.permission.RouterList) {
        getRouterList().then(res => {
          if (res.data.Code === "10000" && !getRouter) {
            getRouter = res.data.Data
            store.dispatch("permission/saveRouterList", getRouter);
            //getRouter = store.state.permission.RouterList
            routerGo(to, next); //执行路由跳转方法
          }
        });
      } else { //从localStorage拿到了路由
        getRouter = store.state.permission.RouterList //拿到路由
        routerGo(to, next); //执行路由跳转方法
      }
    }
    //#endregion
    if (to.meta.auth) { // 判断该路由是否需要登录权限
      // console.log(to.name);
      // console.log(axios);
      // 记录访问日志
      //VisitLog(to.name, to.meta.code);
      if (store.state.user.token != null && store.state.user.UserInfo != null) { // 通过vuex state获取当前的token是否存
        // 判断当前用户是否已拉取完user_info信息
        const userInfo = store.state.user.UserInfo
        next()
      } else {
        next({
          path: '/login',
          query: {
            redirect: from.fullPath
          } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
      }
    } else {
      next()
    }
  }
})

//获取路由列表
async function getRouterList() {
  return axios({
    url: '/Router/GetRouterList',
    method: 'post',
    data: {}
  })
}

//设置路由路径
function routerGo(to, next) {
  var firstOpen = true;
  var routerInfo = filterAsyncRouter(getRouter).reverse(); //过滤路由
  //当前静态路由的name数组
  var StaticRouterNameList = [];
  router.options.routes.forEach(element => {
    StaticRouterNameList.push(element.name);
  })
  routerInfo.forEach(element => {
    //如果动态路由的name已经存在于静态路由中了,则更新静态路由
    if (StaticRouterNameList.indexOf(element.name) >= 0) {
      var name = element.name;
      //如果能找到这个索引，替换对应的对象
      router.options.routes[router.options.routes.indexOf(router.options.routes.find(item => {
        return item.name == name
      }))] = element;
      firstOpen = false;
    }
    //否则将动态路由拼接到静态路由中
    else {
      //倒序拼接
      router.options.routes.unshift(element);
    }
  });
  // console.log('路由：');
  console.log('路由：', routerInfo);
  //router.options.routes = routerInfo.concat(router.options.routes);
  if (firstOpen) {
    router.addRoutes(routerInfo)
  } else {
    //router.addRoutes([])
  }
  next({
    ...to,
    replace: true
  })
}

function filterAsyncRouter(asyncRouterMap) { //遍历后台传来的路由字符串，转换为组件对象
  const res = []
  // 遍历路由数组去重组可用的路由
  asyncRouterMap.forEach(item => {
    const newItem = {}
    newItem['path'] = item.GrantPath
    newItem['name'] = item.GrantName
    newItem['iconCls'] = item.IconPath
    newItem['component'] = item.ComponentPath
    newItem['meta'] = {
      'auth': true,
      'code': item.GrantCode,
      'title': item.GrantName,
      'closable': item.GrantName == '欢迎页面' ? false : true
    }
    newItem['children'] = item.Children
    if (item.IsShow == 1) {
      newItem['hidden'] = false
    } else {
      newItem['hidden'] = true
    }
    if (item.Children && item.Children.length == 1) {
      newItem['redirect'] = item.Children[0].GrantPath;
    }
    res.push(newItem)
  })
  const accessedRouters = res.filter(route => {
    if (route.component) {
      if (route.component === 'main') { //Layout组件特殊处理
        route.component = main;
      } else {
        route.component = LoadView(route.component)
      }
    }
    // 优先删除路由子项为空的属性, 否则会报错
    if (route.children == null || route.children.length < 1) {
      delete route.children;
    }
    if (route.iconCls == null || route.iconCls.length < 1) {
      delete route.iconCls;
    }
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children);
    }
    return true;
  });
  return accessedRouters;
}

//加载视图组件
function LoadView(view) {
  return (resolve) => require([`@/components/${view}`], resolve)
}

//解决渲染一个路由的过程中，需要尝试解析一个异步组件时发生错误
var reRender = 0;
var currPath = "";
router.onError(error => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    if (reRender < 10 && currPath == targetPath) {
      currPath = targetPath;
      router.replace(targetPath);
      reRender++;
    } else {
      reRender = 0;
    }
  }
})

async function VisitLog(name, code) {
  axios.post('/login/AddEnterLog', {
      pagename: name,
      code: code
    }, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then(
      function (res) {

      }
    ) // bind(this)可以不用
    .catch(
      function (err) {
        if (err.response) {

        }
      }
    ) // bind(this) 可以不用
}

//第一次加载页面时读取配置文件到store中。这个配置文件在前端
import {
  getImgFolderConfig
} from "@/js/globalConfig.js";
getImgFolderConfig();

/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: '#app',
  components: {
    App
  },
  template: '<App/>'
})
//导出设定好的axios对象
export {
  axios
}

// export default {
//   name: 'MyComponent',
//   components: {
//     VueSlickCarousel
//   },
// }



// WEBPACK FOOTER //
// ./src/main.js